import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    addSubPackage: {
        packageID: {
            value: "",
            error: "",
            showError: "",
        },
    },
}

const addSubPackage = createNamespacer("ADD_SUB_PACKAGE")

export const addSubPackageReducer = createReducer(initialState.addSubPackage, {
    [addSubPackage("SET_PACKAGE_ID")]:(state, action) => {
        return {
            ...state,
            packageID: {
                ...state.packageID,
                value: action.payload.value,
            },
        }

    },
    [addSubPackage("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.addSubPackage,
        }
    },
    [addSubPackage("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
})